import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import CustomTooltip from '../../CustomTooltip/CustomTooltip';
import IframeRenderer from '../../IframeRenderer/IframeRenderer';

type Props = {
    url: string;
    linkType?: 'infolink' | 'text';
};

const FormFieldTooltip = ({ url , linkType = 'infolink'}: Props) => {
    const trimmedUrl = url?.trim();

    if (!trimmedUrl) {
        return null;
    }

    let TooltipComponent = <div style={{ padding: 16, color: '#000', fontSize: 14 }}>{url}</div>;

    if (linkType === 'infolink') {
        TooltipComponent = <IframeRenderer src={trimmedUrl}/>;
    }

    return (
        <CustomTooltip
            arrow
            lazyMountTitle
            trigger="hover"
            placement="bottom-start"
            slotProps={{
                tooltip: {
                    sx: {
                        p: 0,
                        bgcolor: '#fff',
                        border: '1px solid #d9e2ef',
                        borderRadius: '16px',
                        boxShadow: '0 12px 32px rgba(15, 23, 42, 0.16)',
                        maxWidth: 'none',
                        overflow: 'visible',
                    },
                },
                arrow: {
                    sx: {
                        color: '#878787',
                        '&:before': {
                            border: '1px solid #d9e2ef',
                            boxSizing: 'border-box',
                        },
                    },
                },

                popper: {
                    sx: {
                        zIndex: 1500,
                    },
                },
            }}
            title={() => (
                <div
                    style={{
                        width: 'min(560px, 90vw)',
                        // height: 'min(560px, 70vh)',
                        background: '#fff',
                        overflow: 'hidden',
                        borderRadius: 16,
                    }}
                >
                    {TooltipComponent}
                </div>
            )}
        >
            <InfoOutlined
                fontSize="small"
                style={{
                    cursor: 'pointer',
                    verticalAlign: 'middle',
                    marginLeft: 4,
                    marginTop: 4,
                }}
            />
        </CustomTooltip>
    );
};

export default FormFieldTooltip;